import { aboutValues, brandName, contactInfo, testimonials } from "@/mocks/home";

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <span className="text-xs font-label font-medium tracking-widest text-accent-600">
              ABOUT US
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-black text-foreground-950">
              关于{brandName}
            </h2>
            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-700">
              {brandName}
              是一个把「围观」这件事做得更认真的热点资讯站。我们希望热度之外，事件本身也能被看清：
              谁在说、说了什么、进展到哪一步，读者能在几分钟内拿到一份结构清晰的事件全貌。
            </p>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              我们不做情绪的传声筒，也不靠标题博眼球。核实过的信息标注清楚，未坐实的说法如实说明，
              让每一次围观都建立在可查证的基础上。
            </p>

            <div className="mt-8 rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
              <h3 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2">
                <i className="ri-send-plane-line text-accent-600" aria-hidden="true" />
                联系方式
              </h3>
              <dl className="mt-4 space-y-3 text-sm">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                  <dt className="text-foreground-500 w-20 shrink-0">内容与线索</dt>
                  <dd>
                    <a
                      href={`mailto:${contactInfo.email}`}
                      className="text-foreground-900 underline-offset-4 hover:text-primary-600 hover:underline cursor-pointer break-all"
                    >
                      {contactInfo.email}
                    </a>
                  </dd>
                </div>
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                  <dt className="text-foreground-500 w-20 shrink-0">商务与合作</dt>
                  <dd>
                    <a
                      href={`mailto:${contactInfo.business}`}
                      className="text-foreground-900 underline-offset-4 hover:text-primary-600 hover:underline cursor-pointer break-all"
                    >
                      {contactInfo.business}
                    </a>
                  </dd>
                </div>
              </dl>
              <p className="mt-4 text-xs text-foreground-500 leading-relaxed">
                投稿请尽量附上时间、地点与可验证的佐证材料，编辑会在核实后回复。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <h3 className="font-heading text-xl font-bold text-foreground-950">我们的内容原则</h3>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-5">
              {aboutValues.map((value) => (
                <div
                  key={value.title}
                  className="reveal rounded-lg bg-background-50 border border-background-200 p-5 transition-colors hover:border-accent-300"
                >
                  <span
                    className="w-11 h-11 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center text-xl"
                    aria-hidden="true"
                  >
                    <i className={value.icon} />
                  </span>
                  <h4 className="mt-4 font-heading text-base font-bold text-foreground-950">
                    {value.title}
                  </h4>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{value.desc}</p>
                </div>
              ))}
            </div>

            <h3 className="mt-12 font-heading text-xl font-bold text-foreground-950">读者怎么说</h3>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-5">
              {testimonials.map((item) => (
                <figure
                  key={item.name}
                  className="reveal flex flex-col rounded-lg bg-background-50 border border-background-200 p-5"
                >
                  <i className="ri-double-quotes-l text-2xl text-secondary-400" aria-hidden="true" />
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700 flex-1">
                    {item.quote}
                  </blockquote>
                  <figcaption className="mt-4 pt-4 border-t border-background-200">
                    <p className="text-sm font-medium text-foreground-950">{item.name}</p>
                    <p className="mt-0.5 text-xs text-foreground-500">{item.role}</p>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}